import { useState } from "react";
import AddAttendance from "./AddAttendance";
import DeleteAttendance from "./DeleteAttendance";
import ViewTotalAttendance from "../Faculty/ViewTotalAttendance";
import { FiUserCheck, FiEye } from "react-icons/fi";
import ImportAttendance from "./ImportAttendance";

const Attendence = ({ branch }) => {
  const [activeTab, setActiveTab] = useState('add');
  
  return (
    <div className="w-full space-y-6">
      {/* Header Banner */}
      <div className="bento-header-banner flex items-center justify-between">
        <div>
          <h1 className="text-xl md:text-2xl font-black tracking-tight text-slate-900 dark:text-white">Attendance Management</h1>
          <p className="text-xs md:text-sm text-slate-500 dark:text-slate-400 mt-1">Add, view, import & manage student attendance records {branch ? `for ${branch}` : ''}</p>
        </div>
      </div>

      {/* Tab Navigation */}
      <div className="bento-card p-1.5 bg-slate-100 dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-2xl">
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-1.5">
          <button
            className={`px-4 py-2.5 rounded-xl font-bold text-xs transition-all cursor-pointer ${
              activeTab === "add"
                ? "bg-white dark:bg-slate-800 text-indigo-600 dark:text-indigo-400 shadow-xs border border-slate-200 dark:border-slate-700"
                : "text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white hover:bg-white/50 dark:hover:bg-slate-800/50"
            }`}
            onClick={() => setActiveTab("add")}
          >
            <div className="flex items-center justify-center space-x-2">
              <FiUserCheck className="w-4 h-4" />
              <span>Add Attendance</span>
            </div>
          </button>

          <button
            className={`px-4 py-2.5 rounded-xl font-bold text-xs transition-all cursor-pointer ${
              activeTab === "import"
                ? "bg-white dark:bg-slate-800 text-indigo-600 dark:text-indigo-400 shadow-xs border border-slate-200 dark:border-slate-700"
                : "text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white hover:bg-white/50 dark:hover:bg-slate-800/50"
            }`}
            onClick={() => setActiveTab("import")}
          >
            <div className="flex items-center justify-center space-x-2">
              <FiUserCheck className="w-4 h-4" />
              <span>Import Attendance</span>
            </div>
          </button>

          <button
            className={`px-4 py-2.5 rounded-xl font-bold text-xs transition-all cursor-pointer ${
              activeTab === "view"
                ? "bg-white dark:bg-slate-800 text-indigo-600 dark:text-indigo-400 shadow-xs border border-slate-200 dark:border-slate-700"
                : "text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white hover:bg-white/50 dark:hover:bg-slate-800/50"
            }`}
            onClick={() => setActiveTab("view")}
          >
            <div className="flex items-center justify-center space-x-2">
              <FiEye className="w-4 h-4" />
              <span>View Total</span>
            </div>
          </button>

          <button
            className={`px-4 py-2.5 rounded-xl font-bold text-xs transition-all cursor-pointer ${
              activeTab === "delete"
                ? "bg-white dark:bg-slate-800 text-indigo-600 dark:text-indigo-400 shadow-xs border border-slate-200 dark:border-slate-700"
                : "text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white hover:bg-white/50 dark:hover:bg-slate-800/50"
            }`}
            onClick={() => setActiveTab("delete")}
          >
            <div className="flex items-center justify-center space-x-2">
              <FiUserCheck className="w-4 h-4" />
              <span>Delete Attendance</span>
            </div>
          </button>
        </div>
      </div>

      {/* Content Area */}
      <div className="bg-white dark:bg-slate-900 rounded-2xl shadow-xs border border-slate-200 dark:border-slate-800 p-6 md:p-8">
        {activeTab === "add" && <AddAttendance branch={branch} />}
        {activeTab === "import" && <ImportAttendance branch={branch} />}
        {activeTab === "view" && <ViewTotalAttendance branch={branch} />}
        {activeTab === "delete" && <DeleteAttendance branch={branch} />}
      </div>
    </div>
  );
};

export default Attendence;